export default class HeaderEnum {
    static SWITCH = '[data-element="customer-header-switch"]'
    static SWITCH_LABEL = '[data-element="customer-header-switch-label"]'
}
